import React from 'react'
import { Button, Stack, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import { ROUTES } from '../../constants/routes'

const NotFoundPage: React.FC = () => {
  return (
    <Stack spacing={2} alignItems="center" textAlign="center" mt={8}>
      <Typography variant="h3">404</Typography>
      <Typography variant="body1">This page doesn&apos;t exist.</Typography>
      <Button component={Link} to={ROUTES.HOME} variant="contained">
        Back home
      </Button>
    </Stack>
  )
}

export default NotFoundPage
